import { requestLicenseFile } from '@service/siteLicenseDataService';

export const GET_LICENSE_FILE_SUCCESS = 'GET_LICENSE_FILE_SUCCESS';
export const GET_LICENSE_FILE_ERROR = 'GET_LICENSE_FILE_ERROR';
export const LICENSE_FILE_GET_REQUEST = 'LICENSE_FILE_GET_REQUEST';

export function onLicenseFileGetRequest(siteId: number, siteName: string, accessToken: string) {
    return (dispatch: any) => {
        makeLicenseFileGetRequest(dispatch, siteName, siteId, accessToken);
    };
}

export function makeLicenseFileGetRequest(dispatch: any, siteName: string, siteId: number, accessToken: string) {
    dispatch({ type: LICENSE_FILE_GET_REQUEST });
    return requestLicenseFile(siteName, siteId, accessToken).then(
        (success: any) => {
            dispatch(onLicenseFileGetSuccess());
        },
        (error: any) => {
            dispatch(onLicenseFileGetError());
        }
    );
}

export function onLicenseFileGetSuccess() {
    return {
        type: GET_LICENSE_FILE_SUCCESS,
    };
}

export function onLicenseFileGetError() {
    return {
        type: GET_LICENSE_FILE_ERROR,
        text: 'Error receiving data'
    };
}
